import { ExternalLink, AlertCircle } from "lucide-react";
import { useEffect, useState } from "react";

const DataFetcherGlobal = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url =
          "https://eventos.utpl.edu.ec/jsonapi/node/global_campus?" +
          "fields[node--global_campus]=title,field_contenido,field_estado,field_enlace_contenido,field_enlace";

        const response = await fetch(url);
        if (!response.ok) throw new Error("No se pudo obtener la información.");
        const json = await response.json();

        const items = json.data || [];

        const transformed = items
          .map((item) => {
            const attrs = item.attributes || {};

            // Extraer enlace y su título personalizado
            const rawEnlace =
              attrs.field_enlace || attrs.field_enlace_contenido;
            const urlEnlace =
              typeof rawEnlace === "object" ? rawEnlace?.uri : rawEnlace;

            const titleEnlace =
              typeof rawEnlace === "object" && rawEnlace?.title
                ? rawEnlace.title
                : "Ver convocatoria";

            // Extraer el contenido (puede venir como string directo o dentro de un objeto de texto enriquecido)
            const contenidoRaw = attrs.field_contenido;
            const textoContenido =
              typeof contenidoRaw === "object" && contenidoRaw !== null
                ? contenidoRaw.processed || contenidoRaw.value || ""
                : contenidoRaw || "";

            // Evaluamos si el estado es "abierta" o "abierto"
            const estadoRaw = attrs.field_estado;
            const estadoStr =
              typeof estadoRaw === "string"
                ? estadoRaw.trim().toLowerCase()
                : "";
            const isOpen = [
              "abierta",
              "abierto",
              "open",
              "1",
              "activo",
            ].includes(estadoStr);

            return {
              id: item.id,
              field_nombre_de_evento:
                attrs.field_nombre_de_evento ||
                attrs.title ||
                "Evento sin título",
              field_contenido: textoContenido,
              field_enlace: urlEnlace || "#",
              field_enlace_titulo: titleEnlace,
              isOpen: isOpen,
            };
          })
          // FILTRO: Mantiene únicamente los registros cuyo estado sea abierto
          .filter((evento) => evento.isOpen);

        setData(transformed);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="max-w-6xl mx-auto p-4 flex gap-4 overflow-hidden">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="min-w-[280px] h-48 bg-slate-100 rounded-2xl animate-pulse p-5 flex flex-col justify-between border border-slate-200/60 shrink-0"
          ></div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center p-12">
        <div className="flex items-center gap-3 bg-red-50 text-red-700 border border-red-200 rounded-xl p-4 max-w-md shadow-sm">
          <AlertCircle className="w-5 h-5 shrink-0 text-red-500" />
          <p className="text-sm font-medium">
            Error al cargar los eventos: {error}
          </p>
        </div>
      </div>
    );
  }

  return (
    <section className="  max-w-6xl mx-auto px-4 sm:px-2 lg:px-0">
      {data.length === 0 ? (
        <div className="text-center py-12 text-slate-500">
          No hay convocatorias abiertas registradas por el momento.
        </div>
      ) : (
        /* Contenedor horizontal con scroll lateral */
        <div className="flex overflow-x-auto pb-4 pt-2 gap-4 snap-x snap-mandatory custom-scrollbar">
          {data.map((evento) => (
            <a
              key={evento.id}
              href={
                evento.field_enlace !== "#" ? evento.field_enlace : undefined
              }
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col justify-between bg-white border border-slate-200/80 rounded-2xl p-5 shadow-sm hover:shadow-md hover:border-blue-300 transition-all duration-200 ease-in-out cursor-pointer min-w-[280px] sm:min-w-[300px] max-w-[340px] shrink-0 snap-start"
            >
              <div>
                <h3 className="font-bold text-base p-0  group-hover:text-blue-600 transition-colors  ">
                  {evento.field_nombre_de_evento}
                </h3>

                {/* Impresión de field_contenido (usando dangerouslySetInnerHTML por si viene formateado con HTML desde Drupal) */}
                {evento.field_contenido && (
                  <div
                    className="[&_p]:text-sm   "
                    dangerouslySetInnerHTML={{ __html: evento.field_contenido }}
                  />
                )}
              </div>

              {/* Botón de acción con el título dinámico del enlace */}
              <div className="flex items-center justify-between  border-t border-slate-100">
                <span className="text-xs font-semibold text-slate-500 group-hover:text-blue-500">
                  {evento.field_enlace_titulo}
                </span>
                <span className="inline-flex items-center justify-center text-slate-700 group-hover:text-blue-600 bg-slate-50 group-hover:bg-blue-50 p-2 rounded-xl transition-colors">
                  <ExternalLink className="w-4 h-4" />
                </span>
              </div>
            </a>
          ))}
        </div>
      )}
    </section>
  );
};

export default DataFetcherGlobal;
